import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/personaReferencia";
import {
  PostVerificarDocumentoTitular,
  GetIdentificacionTitularExtranjero
} from "../../../reducers/personaReferencia";

export interface VerificarDocumentoTitularDispatcher {
  postVerificarDocumentoTitular: (
    idMembresiaSocio: number
  ) => Promise<Preview<PostVerificarDocumentoTitular>>;
  getIdentificacionTitularExtranjero: (
    idMembresiaSocio: number
  ) => Promise<Preview<GetIdentificacionTitularExtranjero>>;
  clearPersonaReferencia: () => void;
}

export const verificarDocumentoTitularDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => VerificarDocumentoTitularDispatcher = dispatch => ({
  postVerificarDocumentoTitular: (idMembresiaSocio: number) =>
    dispatch(actions.postVerificarDocumentoTitular(idMembresiaSocio)),
  getIdentificacionTitularExtranjero: (idMembresiaSocio: number) =>
    dispatch(actions.getIdentificacionTitularExtranjero(idMembresiaSocio)),
  clearPersonaReferencia: () => dispatch(actions.clearPersonaReferencia())
});
